import { BadgeType } from '~/shared/components/Badge/styles';

import { CompanyStatusEnum } from '../enums/CompanyStatusEnum';

export const getCompanyStatusColor: Record<CompanyStatusEnum, BadgeType> = {
  active: 'success',
  blocked: 'success',
  canceled: 'error',
  awaiting_contract: 'warning',
  awaiting_signature: 'primary',
  under_analysis: 'warning',
};
